/**
 * Cart Edit Button for Lens Builder Items
 */
(function() {
  'use strict';
  
  console.log('🔧 Lens Builder Cart Edit: Script loaded');
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    console.log('🔧 Lens Builder Cart Edit: Initializing');
    
    // Wait a bit for cart to fully render
    setTimeout(() => {
      addEditButtons();
    }, 500);
    
    // Re-run when cart updates (for dynamic carts)
    document.addEventListener('cart:updated', () => {
      setTimeout(addEditButtons, 500);
    });
  }
  
  function addEditButtons() {
    console.log('🔍 Looking for lens builder items...');
    
    // Find all cart items
    const cartItems = document.querySelectorAll('.cart-items__table-row');
    console.log('📦 Found cart items:', cartItems.length);
    
    cartItems.forEach((row, index) => {
      console.log('🔍 Checking row', index);
      
      // Check if this item has the lens_builder property
      const properties = row.querySelectorAll('.cart-items__properties');
      let isLensBuilderItem = false;
      
      properties.forEach(prop => {
        const dt = prop.querySelector('dt');
        const dd = prop.querySelector('dd');
        
        if (dt && dd) {
          const key = dt.textContent.trim().replace(':', '');
          const value = dd.textContent.trim();
          
          console.log('  Property:', key, '=', value);
          
          if (key === 'lens_builder' || key === '_lens_builder' || key === 'Configuration') {
          isLensBuilderItem = true;
          console.log('  ✅ Found lens builder item!');
          }
        }
      });
      
      if (isLensBuilderItem) {
        // Check if edit button already exists
        if (row.querySelector('.lens-builder-edit-btn')) {
          console.log('  ⏭️ Edit button already exists');
          return;
        }
        
        console.log('  ➕ Adding edit button');
        
        // Create edit button
        const editBtn = document.createElement('button');
        editBtn.className = 'button button--tertiary lens-builder-edit-btn';
        editBtn.type = 'button';
        editBtn.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 0.25rem;">
            <path d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L5.33301 13.3334L1.33301 14.6667L2.66634 10.6667L11.333 2.00004Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Edit Configuration
        `;

        editBtn.style.cssText = `
        margin-top: 0.75rem; 
        font-size: 0.875rem; 
        display: inline-flex; 
        align-items: center; 
        gap: 0.25rem;
        padding: 0.5rem 1rem;
        background-color: transparent;
        color: #346e9f;
        border: 1px solid #346e9f;
        border-radius: 4px;
        cursor: pointer;
        text-decoration: none;
        `;
        
        editBtn.addEventListener('click', () => {
          handleEditClick(row, index);
        });
        
        // Add button to the details cell
        const detailsCell = row.querySelector('.cart-items__details');
        if (detailsCell) {
          detailsCell.appendChild(editBtn);
          console.log('  ✅ Edit button added!');
        } else {
          console.log('  ❌ Could not find details cell');
        }
      }
    });
  }
  
    async function handleEditClick(row, lineIndex) {
    console.log('✏️ Edit clicked for line item:', lineIndex);
    
    // Get the cart item key from the row
    const itemKey = row.dataset.key;
    
    if (!itemKey) {
        console.error('❌ No item key found');
        alert('Unable to edit this item. Please try again.');
        return;
    }
    
    console.log('🔑 Item key:', itemKey);
    
    try {
        // Fetch full cart data from Shopify API
        console.log('📡 Fetching cart data...');
        const response = await fetch('/cart.js');
        const cartData = await response.json();
        
        console.log('📦 Full cart data:', cartData);
        
        // Find the item by key
        const cartItem = cartData.items.find(item => item.key === itemKey);
        
        if (!cartItem) {
        console.error('❌ Cart item not found');
        alert('Unable to find this item in cart.');
        return;
        }
        
        console.log('📦 Cart item:', cartItem);
        console.log('📋 Item properties:', cartItem.properties);
        
        // Look for _config_data in properties
        let configData = null;
        
        if (cartItem.properties && cartItem.properties._config_data) {
        try {
            configData = JSON.parse(cartItem.properties._config_data);
            console.log('✅ Found configuration data:', configData);
        } catch (e) {
            console.error('❌ Error parsing config data:', e);
        }
        } else {
        console.warn('⚠️ No _config_data property found in cart item');
        console.log('Available properties:', Object.keys(cartItem.properties || {}));
        }
        
        // Save to sessionStorage (using NEW key names)
        sessionStorage.setItem('lensBuilderEditKey', itemKey);
        sessionStorage.setItem('lensBuilderFromCart', 'true'); // Flag that we're from cart
        // Don't set lensBuilderFromProduct - that's only for product page

        if (configData) {
          sessionStorage.setItem('lensBuilderEditConfig', JSON.stringify(configData));
          console.log('💾 Saved configuration to sessionStorage');
        } else {
          console.warn('⚠️ No configuration data found - will start fresh');
        }
        
        console.log('🔄 Redirecting to lens builder...');
        
        // Redirect to lens builder page
        window.location.href = '/pages/lens-builder';
        
    } catch (error) {
        console.error('❌ Error fetching cart:', error);
        alert('Unable to load configuration. Please try again.');
    }
    }
  
})();
